"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Radio = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Radio");

var _Radio2 = _interopRequireDefault(_Radio);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _PaymentLogos = require("./PaymentLogos");

var _PaymentLogos2 = _interopRequireDefault(_PaymentLogos);

var _PaymentFormSection = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/PaymentFormSection");

var _PaymentFormSection2 = _interopRequireDefault(_PaymentFormSection);

var _components = require("components");

var _PayPalPaymentBox = require("../../PaymentForm/component/PayPalPaymentBox");

var _PayPalPaymentBox2 = _interopRequireDefault(_PayPalPaymentBox);

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentMethodChoiceRadioButtons = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var radioLabel = (0, _glamor.css)({
  color: _css.colors.gray,
  marginLeft: (0, _css.unitRem)(3),

  "& .text": {
    display: "inline-block",
    verticalAlign: "middle",

    marginLeft: (0, _css.unitRem)(0.5)
  },

  "&:first-child": {
    marginLeft: 0
  }
});

var radio = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
});

var paymentFormFields = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var footer = (0, _glamor.css)(_css.clearfix, {
  marginTop: (0, _css.unitRem)(1.5)
});

var confirmButton = (0, _glamor.css)({
  float: "right"
});
var link = (0, _glamor.css)({
  display: "block",
  fontSize: "0.9375rem",
  fontWeight: "700",
  width: "100%",
  textAlign: "left",
  lineHeight: "2px",
  padding: (0, _css.unitRem)(0.25) + " " + (0, _css.unitRem)(0.125),
  paddingLeft: 0,
  position: "absolute",
  bottom: "7px",
  letterSpacing: "-0.5px",
  color: "#808080",
  cursor: "pointer",
  transition: "box-shadow " + _css.time.fast + ", color " + _css.time.fast + " ease-in-out",

  "&:hover": {
    color: "white",
    transition: "box-shadow " + _css.time.fast + ", color " + _css.time.fast + " ease-in-out"
  },
  "& *": {
    paddingLeft: 0,
    textDecoration: "none"
  }
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  fontSize: "1.125rem"
}));

/* eslint-disable jsx-a11y/label-has-for */
var PaymentSettingsForm = function PaymentSettingsForm(props) {
  return _react2.default.createElement(
    _Form2.default,
    {
      id: props.fields.paymentMethod.value === "cc" ? "creditCardForm" : "paypalForm",
      className: _SubmitArtPopup.popup,
      onSubmit: props.handleSubmit,
      error: props.error,
      message: props.message },
    _react2.default.createElement(
      _PaymentFormSection2.default,
      {
        title: "Payment Settings",
        existingMethod: props.existingMethod,
        hideRule: true,
        nextCharge: props.nextCharge },
      _react2.default.createElement(
        "div",
        { className: paymentMethodChoiceRadioButtons },
        _react2.default.createElement(
          "label",
          { className: radioLabel },
          _react2.default.createElement(_Radio2.default, (0, _extends3.default)({
            disabled: props.updating,
            className: radio
          }, props.fields.paymentMethod, {
            value: "cc",
            label: "Credit Card",
            checked: props.fields.paymentMethod.value === "cc"
          }))
        ),
        _react2.default.createElement(
          "label",
          { className: radioLabel },
          _react2.default.createElement(_Radio2.default, (0, _extends3.default)({
            disabled: props.updating,
            className: radio
          }, props.fields.paymentMethod, {
            value: "paypal",
            label: "PayPal",
            checked: props.fields.paymentMethod.value === "paypal"
          }))
        )
      ),
      _react2.default.createElement(
        "div",
        { className: paymentFormFields },
        props.fields.paymentMethod.value === "cc" && _react2.default.createElement(_components.CreditCardFormFields, {
          creditCardPrepare: props.creditCardPrepare,
          error: props.paypalPaymentBoxError,
          disabled: props.updating,
          fields: props.fields
        }),
        props.fields.paymentMethod.value === "paypal" && _react2.default.createElement(_PayPalPaymentBox2.default, {
          error: props.paypalPaymentBoxError,
          paypalContainerId: props.paypalContainerId,
          paypalEmail: props.paypalEmail
        })
      ),
      _react2.default.createElement(_PaymentLogos2.default, { paymentLogosSrc: props.paymentLogosSrc, braintreeLink: props.braintreeLink })
    ),
    props.renderCaptcha(props.fields.captcha),
    props.onCancelSubscriptionClick && _react2.default.createElement(
      _reactRouter.Link,
      { className: link, onClick: props.onCancelSubscriptionClick },
      "Cancel Subscription"
    ),
    _react2.default.createElement(
      "div",
      { className: footer },
      _react2.default.createElement(_Button2.default, {
        type: "submit",
        className: confirmButton,
        disabled: props.fields.paymentMethod.value === "paypal" && !props.paypalNonce || !!props.message,
        mode: "secondary",
        label: "Save Changes",
        loading: props.updating
      })
    )
  );
};

exports.default = PaymentSettingsForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentSettingsForm/components/PaymentSettingForm.jsx
// module id = 2530
// module chunks = 0